import { Application } from "@hotwired/stimulus"

const application = Application.start()
window.Stimulus = application

const controllers = import.meta.glob("../controllers/*_controller.js", { eager: true })
for (const path in controllers) {
  const match = path.match(/\/([\w-]+)_controller\.js$/)
  if (!match) continue
  const name = match[1].replace(/_/g, "-")
  application.register(name, controllers[path].default)
}
